import PropTypes from 'prop-types';
import './Spinner.css';

export default function Spinner({
  size = 20,
  'aria-label': ariaLabel = 'Cargando',
}) {
  return (
    <span
      className="spinner"
      role="status"
      aria-label={ariaLabel}
      style={{ width: size, height: size }}
    />
  );
}

Spinner.propTypes = {
  size: PropTypes.number,
  'aria-label': PropTypes.string,
};
